import ChartingHighchartsBaseController from './charting_highcharts_base_controller';

export default class extends ChartingHighchartsBaseController {
  // eslint-disable-next-line class-methods-use-this -- polymorphic override
  resolveClickValue(point, _member) {
    return point.category || point.name || point.x;
  }
}
